import { BarChart3, Inbox, Users, UserCog } from "lucide-react";

export const ADMIN_NAV = [
  { href: "/admin", label: "Resumen", icon: <BarChart3 size={16} /> },
  { href: "/admin/jugadores", label: "Jugadores", icon: <Users size={16} /> },
  { href: "/admin/equipo", label: "Equipo", icon: <UserCog size={16} /> },
  { href: "/admin/contactos", label: "Mensajes", icon: <Inbox size={16} /> },
];
